import "./index.css";
import { useAuth } from "../auth/AuthContext";
import GuestHomePageComponent from "../components/home/GuestHomePageComponent";
import LoggedInHomePageComponent from "../components/home/LoggedInHomePageComponent";
import { Box, CircularProgress } from "@mui/material";

const HomePage = () => {
  const { isAuthenticated, isLoading } = useAuth();
  
  // Show loading spinner while auth is initializing
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  return isAuthenticated ? <LoggedInHomePageComponent /> : <GuestHomePageComponent />;
};

export default HomePage;